(function () {
	'use strict'

	function initCarousel(root) {
		if (!root || root.dataset.carouselInit === 'true') return

		var slides = root.querySelectorAll('[data-section-carousel-slide]')
		if (slides.length <= 1) return

		root.dataset.carouselInit = 'true'

		var current = 0
		var autoplay = root.dataset.autoplay === 'true'
		var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000
		var timer = null
		var dots = root.querySelectorAll('[data-section-carousel-dot]')
		var prevBtn = root.querySelector('[data-section-carousel-prev]')
		var nextBtn = root.querySelector('[data-section-carousel-next]')

		function goTo(index) {
			slides[current].classList.remove('is-active')
			if (dots[current]) dots[current].classList.remove('is-active')

			current = (index + slides.length) % slides.length

			slides[current].classList.add('is-active')
			if (dots[current]) dots[current].classList.add('is-active')
		}

		function next() {
			goTo(current + 1)
		}

		function prev() {
			goTo(current - 1)
		}

		function startAutoplay() {
			stopAutoplay()
			if (autoplay) {
				timer = setInterval(next, speed)
			}
		}

		function stopAutoplay() {
			if (timer) {
				clearInterval(timer)
				timer = null
			}
		}

		if (prevBtn) {
			prevBtn.addEventListener('click', function () {
				prev()
				startAutoplay()
			})
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function () {
				next()
				startAutoplay()
			})
		}

		dots.forEach(function (dot) {
			dot.addEventListener('click', function () {
				var index = parseInt(dot.dataset.carouselDot, 10)
				goTo(index)
				startAutoplay()
			})
		})

		root.addEventListener('mouseenter', stopAutoplay)
		root.addEventListener('mouseleave', startAutoplay)

		startAutoplay()
	}

	function initScrollCarousel(root) {
		if (!root || root.dataset.scrollInit === 'true') return

		var track = root.querySelector('[data-scroll-track]')
		if (!track) return

		root.dataset.scrollInit = 'true'

		var prevBtn = root.querySelector('[data-scroll-prev]')
		var nextBtn = root.querySelector('[data-scroll-next]')

		function getScrollAmount() {
			return track.clientWidth
		}

		if (prevBtn) {
			prevBtn.addEventListener('click', function () {
				track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' })
			})
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function () {
				track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' })
			})
		}
	}

	function initAll() {
		document.querySelectorAll('[data-section-carousel]').forEach(initCarousel)
		document.querySelectorAll('[data-scroll-carousel]').forEach(initScrollCarousel)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll)
	} else {
		initAll()
	}

	document.addEventListener('shopify:section:load', initAll)
})()
